export default function HeroSection() {
  return (
    <section
      id="home"
      className="relative min-h-screen w-full flex items-center justify-center overflow-hidden"
    >
      {/* Background Image */}
      <div className="absolute inset-0 w-full h-full">
        <img
          src="https://public.readdy.ai/ai/img_res/459ff972200990f30ed935e1c98d4919.jpg"
          alt="Hero background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/50 to-black/75" />
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 lg:px-12 flex flex-col items-center text-center">
        <span className="inline-block px-4 py-1.5 rounded-full border border-emerald-400/40 text-emerald-300 text-xs font-semibold tracking-widest uppercase mb-6 bg-emerald-900/20">
          iOS Platform Specialists
        </span>
        <h1 className="text-5xl lg:text-7xl font-extrabold text-white leading-tight tracking-tight max-w-4xl">
          Engineering Excellence<br />
          <span className="text-emerald-400">for iOS</span>
        </h1>
        <p className="mt-6 text-lg lg:text-xl text-white/70 max-w-2xl leading-relaxed">
          A team of dedicated experts crafting premium iOS applications that elevate user experience, safeguard privacy, and maximize device performance.
        </p>

        {/* Scroll indicator */}
        <div className="mt-16 flex flex-col items-center gap-2 text-white/40">
          <span className="text-xs tracking-widest uppercase">Scroll to explore</span>
          <div className="w-px h-12 bg-gradient-to-b from-white/30 to-transparent" />
        </div>
      </div>
    </section>
  );
}
